import {
  Button,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from "@mui/material";
import { makeStyles } from '@mui/styles';
import React, { useState, useRef, memo } from "react";
import ConfirmDialog from "../../customComponents/confirm.dialog";
import Draggable from "../../customComponents/draggable";

const useStyles = makeStyles((theme) => ({
  square: {
    background: theme.palette.background.paper,
    border: ({ isLocked, status }) =>
      `8px ${isLocked ? "solid" : "dashed"} ${status ? '#f44336' : '#4caf50'}`,
    borderRadius: theme.shape.borderRadius,
    height: 50,
    width: 50,
    display: "grid",
    alignItems: "center",
    justifyItems: "center",
    fontSize: 20,
    userSelect: "none",
    color: '#fff',
    fontWeight: 'bold'
  },
  squareButton: {
    padding: "0 !important",
    minWidth: "auto !important",
  },
}));

const OwnerRoomTable = memo(({
  canvasRef,
  table,
  setCoords,
  isLocked,
  deleteTable,
  onOpenOrder,
  onOpenView,
  isMobile
}) => {
  const classes = useStyles({ isLocked, status: table.status });
  const [openMenu, setOpenMenu] = useState(false);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const anchorRef = useRef(null);

  const handleToggleMenu = (e) => {
    e.stopPropagation();
    setOpenMenu((prev) => !prev);
  };

  const handleCloseMenu = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) return;
    setOpenMenu(false);
  };

  const handleAction = (type) => (e) => {
    e.stopPropagation();
    setOpenMenu(false);
    if (type === 'view') onOpenView(table);
    if (type === 'order') onOpenOrder(table);
    if (type === 'delete') setOpenDeleteConfirm(true);
  };

  const confirmDelete = (result) => {
    if (result) deleteTable(table.id, table.businessId);
    setOpenDeleteConfirm(false);
  };

  const updateCoords = (e) => {
    setCoords(table.id, e.coords.x, e.coords.y, table.businessId);
  };


  const tableUI = (
    <div style={{
      position: isMobile ? 'relative' : 'absolute',
      // Se non è mobile, usiamo le coordinate esatte. Se è mobile, lasciamo fare al Flexbox.
      left: isMobile ? 'unset' : table.x,
      top: isMobile ? 'unset' : table.y,
      display: 'inline-flex', // Cambiato da 'flex' a 'inline-flex' per non occupare il 100%
      flexDirection: 'column',
      alignItems: 'center',
      zIndex: isLocked ? 10 : 1,
      margin: 0,
    }}>
      <Button
        className={classes.squareButton}
        ref={anchorRef}
        onClick={handleToggleMenu}
        style={{ minWidth: 'unset', borderRadius: '8px' }}
      >
        <div className={classes.square}>{table.id}</div>
      </Button>

      <Popper
        open={openMenu}
        anchorEl={anchorRef.current}
        transition
        disablePortal={false}
        style={{ zIndex: 1500 }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{ transformOrigin: placement === "bottom" ? "center top" : "center bottom" }}
          >
            <Paper elevation={8}>
              <ClickAwayListener onClickAway={handleCloseMenu}>
                <MenuList autoFocusItem={openMenu}>
                  <MenuItem onClick={handleAction('view')}>Visualizza</MenuItem>
                  <MenuItem onClick={handleAction('order')}>Ordina</MenuItem>
                  {!table.status && (
                    <MenuItem onClick={handleAction('delete')} style={{ color: '#d32f2f' }}>
                      Elimina
                    </MenuItem>
                  )}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>

      <ConfirmDialog
        open={openDeleteConfirm}
        handleClose={confirmDelete}
        text={{
          text: "Elimina tavolo",
          description: `Vuoi eliminare definitivamente il tavolo ${table.id}?`,
        }}
      />
    </div>
  );

  if (isMobile) return tableUI;

  return (
    <Draggable
      containerRef={canvasRef}
      onDragEnd={updateCoords}
      startingCoords={{ x: table.x, y: table.y }}
      disableDrag={isLocked}
    >
      {/* Quando è bloccato usiamo tableUI (absolute), quando è sbloccato lasciamo fare al Draggable */}
      {isLocked ? tableUI : <div className={classes.square}>{table.id}</div>}
    </Draggable>
  );
});

export default OwnerRoomTable;